import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqSections = [
    {
        title: 'Retool Your School FAQs',
        items: [
            {
                q: 'What types of organizations/institutions does the Retool Your School Program support?',
                a: (
                    <>
                        <Typography paragraph>
                            Only Institutions of Higher Education (“IHE”) designated by the Secretary of Education as accredited 4-year colleges and universities, 2-year community colleges, that meet the eligibility requirements can enroll in The Home Depot Retool Your School Program.
                        </Typography>
                    </>
                )
            },
            {
                q: 'What are the specific eligibility requirements?',
                a: (
                    <>
                        <ul>
                            <li>Current accreditation status</li>
                            <li>Current student enrollment under 16,000</li>
                            <li>The school's endowment must be under $500,000,000.00.</li>
                        </ul>
                    </>
                )
            },
            {
                q: 'What grants are available through the Retool Your School Program?',
                a: (
                    <>
                        <Typography paragraph>Candidates may be considered for:</Typography>
                        <ul>
                            <li>Campus Improvement Grant</li>
                            <li>Innovation Lounge Grant</li>
                        </ul>
                    </>
                )
            },
            {
                q: 'How can a higher learning institution apply for a grant?',
                a: (
                    <Typography paragraph>
                        Schools can apply using the link on retoolyourschool.com during the open application time frame.
                    </Typography>
                )
            },
            {
                q: 'Who can apply for a Retool Your School grant on behalf of my institution?',
                a: (
                    <>
                        <Typography paragraph>
                            Only an employee of the institution can apply for a Retool Your School grant using an email address that contains the institution's domain. If a non-employee applies, the institution will be pulled from consideration for the year’s grant cycle without the opportunity to submit a new application.
                        </Typography>
                    </>
                )
            },
            {
                q: 'How many applications can be submitted on behalf of my institution?',
                a: (
                    <Typography paragraph>Only one application can be submitted per institution per year. The first application successfully submitted will be accepted.</Typography>
                )
            },
            {
                q: 'I am having trouble with my institution’s application. Who can I contact?',
                a: (
                    <Typography paragraph>
                        Submit your questions to <a href="mailto:retoolyourschool@homedepot.com" style={{ color: '#F96302' }} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); window.location.href = 'mailto:retoolyourschool@homedepot.com'; }}>retoolyourschool@homedepot.com</a> and a Retool Your School program team member will respond within 48 hours.
                    </Typography>
                )
            },
            {
                q: 'Can we promote our institution’s involvement with the Retool Your School Program? Are there any stipulations for media coverage?',
                a: (
                    <>
                        <Typography paragraph>
                            Yes, your school can promote your participation in the program. However, no applicants or representatives can take part (or agree to take part) in any media interviews or events or issue any press releases or other announcements regarding participation in the Retool Your School Program without the prior written consent of The Home Depot.
                        </Typography>
                        <Typography paragraph>
                            Written communications guidelines (includes media materials, external communications, social media) will be sent to Grantees. These guidelines outline the communication materials requested by The Home Depot’s PR Team and the process for getting related communications submitted and approved.
                        </Typography>
                    </>
                )
            },
            {
                q: 'Does the Retool Your School Program accept unsolicited grant requests?',
                a: (
                    <Typography paragraph>No. Applicants must apply for one of the available grants during the open application time frame.</Typography>
                )
            },
            {
                q: 'I\'ve read through all the materials, but I still have questions. How can I contact someone from the Retool Your School Program team?',
                a: (
                    <Typography paragraph>
                        Submit your questions to <a href="mailto:retoolyourschool@homedepot.com" style={{ color: '#F96302' }} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); window.location.href = 'mailto:retoolyourschool@homedepot.com'; }}>retoolyourschool@homedepot.com</a> and a Retool Your School program team member will respond within 48 hours.
                    </Typography>
                )
            },
            {
                q: 'Can I vote for my institution to receive a Grant?',
                a: (
                    <Typography paragraph>No. There is no voting process for any of the grants. Recipients of the Campus Improvement Grant are selected based on criteria set by The Home Depot.</Typography>
                )
            },
            {
                q: 'Can I use my school\'s hashtag on social media to promote my school\'s participation in the program?',
                a: (
                    <Typography paragraph>Yes, you can use your school's hashtag along with the hashtag #RetoolYourSchool to promote your school's participation in the Program as well as any completed projects.</Typography>
                )
            },
            {
                q: 'What is the 2026 application timeline?',
                a: (
                    <>
                        <ul>
                            <li>Grant Applications Intake Period: Monday May 11, 2026 – Sunday June 7, 2026</li>
                            <li>Grant Recipients Publicly Announced: September 2026</li>
                        </ul>
                    </>
                )
            },
            {
                q: 'When will the grants be awarded?',
                a: (
                    <Typography paragraph>All grants will be publicly announced in September and awarded after the announcement.</Typography>
                )
            },
            {
                q: 'How can I sign up to receive notifications and communications about the program?',
                a: (
                    <Typography paragraph>
                        Please email <a href="mailto:retoolyourschool@homedepot.com?subject=FY26%20Email%20Opt-in&body=I%20would%20like%20to%20receive%20updates%20from%20The%20Home%20Depot's%20Retool%20Your%20School%20Grant%20Program&bcc=rys@goldlasso.com" style={{ color: '#F96302' }} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); window.location.href = "mailto:retoolyourschool@homedepot.com?subject=FY26%20Email%20Opt-in&body=I%20would%20like%20to%20receive%20updates%20from%20The%20Home%20Depot's%20Retool%20Your%20School%20Grant%20Program&bcc=rys@goldlasso.com"; }}>retoolyourschool@homedepot.com</a> for more information.
                    </Typography>
                )
            },
            {
                q: 'Can Applications be edited after submission?',
                a: (
                    <Typography paragraph>No, applications cannot be submitted after submission.</Typography>
                )
            }
        ]
    },
    {
        title: 'Campus Improvement Grant FAQs',
        items: [
            {
                q: 'What is the focus of the Campus Improvement Grant?',
                a: (
                    <Typography paragraph>
                        The Retool Your School Program provides the opportunity for colleges and universities to receive grants from The Home Depot to be used for campus improvement projects that promote sustainability and long-term benefits to the campus and students.
                    </Typography>
                )
            },
            {
                q: 'What is the 2026 timeline for Campus Improvement Grants?',
                a: (
                    <ul>
                        <li>Grant Applications Intake Period: Monday, May 11, 2026 – Sunday, June 7, 2026</li>
                        <li>Grant Recipients Announced: September 2026</li>
                    </ul>
                )
            },
            {
                q: 'How can my school use the Campus Improvement Grant funds?',
                a: (
                    <Typography paragraph>
                        Grants can be used for materials and/or services available through The Home Depot and Home Services at The Home Depot. Grants cannot be used for tool rentals or tool rental deposits. Other services provided by contractors can be paid by using the cash portion of the grant.
                    </Typography>
                )
            },
            {
                q: 'What is the Campus Improvement Grant worth?',
                a: (
                    <Typography paragraph>Each of the Campus Improvement Grants will be valued at $200K.</Typography>
                )
            },
            {
                q: 'When will the Campus Improvement Grant awards be funded to the winning schools?',
                a: (
                    <Typography paragraph>All grants will be distributed during the fall of 2026 after the agreement has been completed.</Typography>
                )
            },
            {
                q: 'If my school does not finish a Campus Improvement Grant project by the end of the calendar year, do we lose the money?',
                a: (
                    <Typography paragraph>No. A school will not lose their grant funds if they do not complete the Campus Improvement Grant project by the end of the calendar year.</Typography>
                )
            }
        ]
    },
    {
        title: 'Innovation Lounge Grant FAQ',
        items: [
            {
                q: 'What is the Innovation Lounge Grant?',
                a: (
                    <Typography paragraph>
                        Innovation Lounge Grants will help provide on-campus spaces where students can come together to do schoolwork, ideate, or explore entrepreneurship or career path opportunities. Innovation Lounges can also be used to host hybrid meetings and webinars.
                    </Typography>
                )
            },
            {
                q: 'What does the Innovation Lounge grant include?',
                a: (
                    <>
                        <Typography paragraph>
                            The Innovation Lounge Grant provides funding for building materials like paint, flooring, lighting, and drywall to support repairs. The grant also covers a furniture package and technology package that will be provided.
                        </Typography>
                        <Typography paragraph>
                            An Innovation Lounge Grant does not include funding for new construction, demolition and rebuild, or for spaces requiring the support of a general contractor or building permits to complete.
                        </Typography>
                    </>
                )
            },
            {
                q: 'What is the Innovation Lounge Grant worth?',
                a: (
                    <Typography paragraph>Each Innovation Lounge Grant is valued at $75K.</Typography>
                )
            },
            {
                q: 'What are the eligibility requirements to be considered for the Innovation Lounge Grant?',
                a: (
                    <>
                        <Typography paragraph>
                            A school must submit a proposal for the opportunity to receive an Innovation Lounge Grant. Proposals will be judged based on certain criteria set by The Home Depot. These criteria include, but are not limited to:
                        </Typography>
                        <ol>
                            <li>School has not previously been awarded an Innovation Lounge.</li>
                            <li>Proposed space is less than 1,000 sq. ft.</li>
                            <li>Only minor repairs are needed to refresh the space (no major renovations).</li>
                            <li>School has provided a clear description of the project.</li>
                            <li>Scope of work can be completed within designated timeline and budget.</li>
                        </ol>
                    </>
                )
            },
            {
                q: 'How many Innovation Lounge Grants will be awarded annually?',
                a: (
                    <Typography paragraph>Fourteen schools will be selected based on criteria set by The Home Depot.</Typography>
                )
            },
            {
                q: 'How will the Innovation Lounge Grant funds be distributed?',
                a: (
                    <Typography paragraph>
                        A portion of the funds will be issued in the form of Home Depot gift cards, and the remaining grant funds will cover a furniture package and technology package that will be provided.
                    </Typography>
                )
            },
            {
                q: 'Can I win the Innovation Lounge Grant if my institution has won previously?',
                a: (
                    <Typography paragraph>No. The Innovation Lounge Grant may not be won more than once by any eligible institution.</Typography>
                )
            },
            {
                q: 'How can my school use Innovation Lounge Grant funds?',
                a: (
                    <>
                        <Typography paragraph>
                            Grant funds can be used for the purpose of refreshing an existing campus space of up to 1,000 sq. ft. Funding covers building materials like paint, flooring, lighting, and drywall needed to support repairs. The grant also provides a furniture package and technology package that will be provided.
                        </Typography>
                        <Typography paragraph>
                            An Innovation Lounge Grant does not include funding for new construction, demolition and rebuild, or spaces requiring the support of a general contractor or building permits to complete.
                        </Typography>
                    </>
                )
            },
            {
                q: 'What is the breakdown of the Innovation Lounge Grant?',
                a: (
                    <>
                        <Typography paragraph><strong>BUILDING MATERIALS – Up to $34,000</strong></Typography>
                        <Typography paragraph>
                            Schools will receive up to $34K in gift cards that can be used at The Home Depot store (in-store or online) to purchase materials to refresh their space for the Innovation Lounge, including supplies for painting, flooring, lighting, ceiling tile, wood, drywall, and other materials for repairs. Gift cards can also be used for installation services when purchased through The Home Depot Home Services (see store for details). Schools must provide a quote for material and installation expenses to The Home Depot prior to receiving their gift cards.
                        </Typography>
                        <Typography paragraph><strong>FURNITURE – Up to $25,000</strong></Typography>
                        <Typography paragraph>
                            Schools will choose from two pre-selected furniture package options valued up to $25K. The furniture package includes costs for freight, assembly, and installation. Schools will receive a link to select their furniture package.
                        </Typography>
                        <Typography paragraph><strong>TECHNOLOGY – Up to $7,000</strong></Typography>
                        <Typography paragraph>
                            The technology package includes a scheduled site visit from our vendor prior to the shipping and installation of an All-in-One Desk-top Computer and integrated 75-inch display. Additionally, maintenance and support fees for the 75-inch display is included for five-years. For the sixth year and beyond, the maintenance and support for the technology package will become the responsibility of the school.
                        </Typography>
                        <Typography paragraph><strong>MISC EXPENSES – Up to $9,000</strong></Typography>
                        <Typography paragraph>
                            Schools will receive a Retool Your School Innovation Lounge sign to hang in the lounge as well as a Celebration Box for ribbon cutting or grand opening ceremonies. With appropriate documentation and prior approval from The Home Depot, a small contingency fund is set aside to cover unexpected expenses associated with the repair of the Innovation Lounge space.
                        </Typography>
                    </>
                )
            }
        ]
    }
];

export default function FAQ({ openQuestion }) {
    const [expandedPanel, setExpandedPanel] = useState(false);

    const normalizeQuestion = (value) => {
        if (!value) return '';
        return String(value)
            .toLowerCase()
            .replace(/[\u2018\u2019]/g, "'")
            .replace(/[\u201c\u201d]/g, '"')
            .replace(/\s+/g, ' ')
            .trim();
    };

    // openQuestion is an optional prop passed from InfoModal to pre-open a specific accordion
    // match by exact question text and set the expanded panel accordingly
    function findPanelForQuestion(q) {
        if (!q) return false;
        const target = normalizeQuestion(q);
        for (let si = 0; si < faqSections.length; si++) {
            const section = faqSections[si];
            for (let ii = 0; ii < section.items.length; ii++) {
                if (normalizeQuestion(section.items[ii].q) === target) {
                    return `${si}-${ii}`;
                }
            }
        }
        return false;
    }

    useEffect(() => {
        const panel = findPanelForQuestion(openQuestion);
        if (panel) {
            setExpandedPanel(panel);
            const isBreakdownTarget = normalizeQuestion(openQuestion) === normalizeQuestion('What is the breakdown of the Innovation Lounge Grant?');
            const scrollToPanel = (behavior = 'smooth') => {
                const el = document.getElementById(`faq-panel-${panel}`);
                if (!el) return;
                const scrollContainer = el.closest('.MuiDialogContent-root');
                if (scrollContainer) {
                    if (isBreakdownTarget) {
                        scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior });
                        return;
                    }
                    const containerRect = scrollContainer.getBoundingClientRect();
                    const elementRect = el.getBoundingClientRect();
                    const topPadding = 38;
                    const top = Math.max(
                        0,
                        scrollContainer.scrollTop + (elementRect.top - containerRect.top) - topPadding
                    );
                    scrollContainer.scrollTo({ top, behavior });
                    return;
                }
                if (typeof el.scrollIntoView === 'function') {
                    el.scrollIntoView({ behavior, block: 'start' });
                }
            };

            requestAnimationFrame(() => {
                requestAnimationFrame(() => scrollToPanel());
            });

            const t1 = setTimeout(() => scrollToPanel('smooth'), 220);
            const t2 = setTimeout(() => scrollToPanel('smooth'), 500);
            const t3 = setTimeout(() => scrollToPanel('auto'), 900);

            return () => {
                clearTimeout(t1);
                clearTimeout(t2);
                clearTimeout(t3);
            };
        }
    }, [openQuestion]);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panel : false);
    };

    return (
        <Container sx={{ py: 4 }}>
            <Typography variant="h4" sx={{ mb: 2 }}>Frequently Asked Questions</Typography>
            {faqSections.map((section, sIdx) => (
                <div key={section.title} style={{ marginBottom: 24 }}>
                    <Typography variant="h5" sx={{ mb: 1, color: '#F96302' }}>{section.title}</Typography>
                    {section.items.map((it, idx) => {
                        const key = `${sIdx}-${idx}`;
                        return (
                            <Accordion id={`faq-panel-${key}`} key={section.title + idx} sx={{ mb: 1.5 }} expanded={expandedPanel === key} onChange={handleChange(key)}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography sx={{ fontWeight: 600 }}>{it.q}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {it.a}
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                </div>
            ))}
        </Container>
    );
}
